<template>
    <div class="border-b border-amber-300 bg-amber-50 dark:bg-amber-950/40 text-amber-900 dark:text-amber-300">
        <div class="container flex flex-col gap-2 py-3 text-sm sm:flex-row sm:items-center sm:justify-between">
            <p>
                <strong>Náhľad</strong> – {{ label }}
                <span v-if="!canShare">Zdieľal ti ho niekto cez odkaz na náhľad, prosím, nešír ho ďalej.</span>
            </p>
            <CButton
                v-if="canShare"
                class="shrink-0"
                :loading="isLoading"
                size="small"
                variant="primary-150"
                @click="copyPreviewLink"
            >
                {{ isCopied ? 'Odkaz skopírovaný' : 'Kopírovať odkaz na náhľad' }}
            </CButton>
        </div>
        <p v-if="errorMessage" class="container pb-3 text-sm text-red-700 dark:text-red-300">{{ errorMessage }}</p>
    </div>
</template>

<script setup lang="ts">
import { useAuthFetch } from '@/composables/useAuthFetch'

interface Props {
    type: 'job' | 'blog'
    id: string
    label: string
    /** True for people who manage the document — they can hand out the preview link. */
    canShare?: boolean
}

const props = defineProps<Props>()

const { authFetch } = useAuthFetch()
const isLoading = ref(false)
const isCopied = ref(false)
const errorMessage = ref('')

/**
 * Fetches (or creates) the document's preview token and copies a shareable link.
 */
async function copyPreviewLink() {
    isLoading.value = true
    errorMessage.value = ''
    try {
        const { token } = await authFetch<{ token: string }>('/api/preview-link', {
            method: 'POST',
            body: { type: props.type, id: props.id }
        })
        const url = new URL(window.location.pathname, window.location.origin)
        url.searchParams.set('preview', token)
        await navigator.clipboard.writeText(url.toString())
        isCopied.value = true
    } catch (error) {
        console.error('[PreviewBanner] Failed to create preview link:', error)
        errorMessage.value = 'Odkaz na náhľad sa nepodarilo vytvoriť.'
    } finally {
        isLoading.value = false
    }
}
</script>
